import micro_reporter_api from "../../apis/micro-reporter-api";

export class ReportScheduleService {

    getAllScheduleByUser(userId) {

        return new Promise((resolve, reject) => {
            micro_reporter_api.get(`/micro-reporter/schedule/user?userId=${userId}`).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })

    }

        createReportSchedule(request) {

        return new Promise((resolve, reject) => {
            micro_reporter_api.post("/micro-reporter/schedule/save",request).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }


    updateReportSchedule(reportSchedule) {
        return new Promise((resolve, reject) => {
            micro_reporter_api.post("/micro-reporter/schedule/update", reportSchedule).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    deleteReportSchedule(id) {
        return new Promise((resolve, reject) => {
            micro_reporter_api.delete("/micro-reporter/schedule/by-id/"+id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    getReportScheduleById(id) {
        return new Promise((resolve, reject) => {
            micro_reporter_api.get("/micro-reporter/schedule/by-id/"+id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }

    getReportById(id) {
        return new Promise((resolve, reject) => {
            micro_reporter_api.get("/micro-reporter/report/find-by-id?id="+id).then(res => {
                resolve(res.data)
            }).catch(err => {
                reject(err)
            })
        })
    }
}
